var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('px-oferta-duvidas-list',{ref:"duvidasList",attrs:{"is-fornecedor":"","oferta":_vm.oferta,"method-getter-fornecedor":_vm.ofertaService.getDuvidas,"method-responder":_vm.ofertaService.responderDuvidas}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }